<template>
    <section class="hero is-fullheight">
        <div class="hero-head">
            <commemoria-navbar></commemoria-navbar>
            <div class="container is-fluid">
                <header class="level">
                    <!-- Left side -->
                    <div class="level-left">
                        <div class="level-item">
                            <b-dropdown id="timelines-visibility" v-model="visibility" position="is-bottom-left" aria-role="list">
                                <p class="title" style="font-size: 1.5rem;" slot="trigger">
                                    <span v-if="visibility == 'personal'">Lignes du temps personnelles</span>
                                    <span v-if="visibility == 'shared'">Lignes du temps partagées avec moi</span>
                                    <span v-if="visibility == 'public'">Lignes du temps publiques</span>
                                    <span> &nbsp; </span>
                                    <i class="fa fa-angle-down"></i>
                                </p>
                                
                                <b-dropdown-item :value="'personal'" aria-role="listitem" @click="fetchUserTimelines()">Lignes du temps personnelles
                                </b-dropdown-item>
                                <b-dropdown-item :value="'shared'" aria-role="listitem" @click="fetchUserTimelines()">Lignes du temps partagées avec moi
                                </b-dropdown-item>
                                <hr class="dropdown-divider">
                                <b-dropdown-item :value="'public'" aria-role="listitem" @click="fetchTimelinesCatalog()">Lignes du temps publiques</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                    <!-- Right side -->
                    <div class="level-right" v-if="visibility !== 'public'">
                        <div class="level-item">
                            <button class="button is-primary" @click="createModal()">Créer une ligne du temps</button>
                        </div>
                    </div>
                </header>
            </div>
        </div>
        <div class="hero-body" style="padding-top: 0.75rem;">
            <div class="container is-fluid">
                <div class="columns is-multiline" v-if="!loading">
                    <template v-if="timelines.length">
                        <div class="column is-4" v-for="timeline in filteredTimelines" :key="timeline.id">
                            <div class="box" style="position: relative; padding: 0.75rem; height: 200px;">
                                <router-link :to="{ name: 'timelines.show', params: { id: timeline.id }}" class="media" style="color: #363636; height: 160px;"exact>
                                    <figure class="media-left" v-if="timeline.avatar">
                                        <p class="image" style="width: 96px; height: 96px;">
                                            <img :src="timeline.avatar.url">
                                        </p>
                                    </figure>
                                    <div class="media-content">
                                        <div>
                                            <b class="has-text-primary" style="max-width: 40ch;margin-bottom: 5px;">
                                                {{ timeline.title }}
                                            </b>
                                        </div>
                                        <p style="font-size: 90%;">
                                            {{ timeline.description }}
                                        </p>
                                    </div>
                                </router-link>
                                <div class="level">
                                    <div class="level-left has-text-grey-light" style="font-size: 80%;">
                                        <div class="level-item">
                                            <i class="fa fa-calendar"></i> &nbsp; {{ timeline.events }}
                                        </div>
                                        <div class="level-item" v-if="timeline.shared == true">
                                            <i class="fa fa-users" aria-hidden="true" style="line-height: 1.2;"></i>
                                        </div>
                                            
                                        <div class="level-item" v-if="timeline.published == true">
                                            <i class="fa fa-globe" aria-hidden="true" style="line-height: 1.2;"></i>
                                        </div>
                                    </div>
                                    <div class="level-right" style="align-self: flex-start;">
                                        <div class="level-item">
                                            <b-dropdown position="is-bottom-left" style="cursor: pointer;">
                                                <i class="fa fa-ellipsis-h" slot="trigger"></i>
                                                <!--<b-dropdown-item>Présenter</b-dropdown-item>-->
                                                <b-dropdown-item @click="addTimelineToContextualizationTimelines(timeline)">
                                                    <i class="fa fa-cubes" aria-hidden="true" style="line-height: 1.2; margin-right: 10px;"></i>Contextualiser
                                                </b-dropdown-item>
                                                <!--<b-dropdown-item>Partager</b-dropdown-item>-->
                                            </b-dropdown>
                                        </div>
                                    </div>
                                    <!--    -->
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="column is-4 is-offset-4 has-text-centered" v-else>
                        <p v-if="visibility == 'personal'">
                            Vous n'avez pour l'instant aucune ligne du temps
                        </p>
                        <p v-if="visibility == 'shared'">
                            Il n'y pas de lignes du temps qui ont été partagées avec vous.
                        </p>
                        <p v-if="visibility == 'public'">
                            Il n'y a pas de lignes du temps publiques actuellement.
                        </p>
                        <br />
                        <p v-if="visibility == 'personal'">
                            <a class="button is-primary" @click="createModal()">Créer une ligne du temps</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-foot">
            <commemoria-footer></commemoria-footer>
        </div>
        <b-loading :active.sync="loading"></b-loading>
        <template v-if="!loading">
            <div style="height:144px;" v-if="contextualizationPanel.visible && contextualizationPanel.extended"></div>
            <contextualization-panel></contextualization-panel>
        </template>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                timelines: [],
                policies: [],
                visibility: 'personal',
            }
        },

        computed: {
            contextualizationTimelines() {
                return this.$store.getters.contextualizationTimelines;
            },

            contextualizationPanel() {
                return this.$store.getters.contextualizationPanel;
            },

            user() {
                return this.$store.state.account;
            },

            filteredTimelines() {

                if (this.visibility == 'personal') {
                    return _.filter(this.timelines, { 'personal': true });
                }

                if (this.visibility == 'shared') {
                    return _.filter(this.timelines, { 'personal': false });
                }

                return this.timelines;
            }
        },

        methods: {
            createModal() {
                this.$buefy.modal.open({
                    parent: this,
                    component: require('../../modals/createTimeline').default,
                    props: {
                        'authorized': this.policies.create,
                        'events': [],
                    },
                    hasModalCard: true
                });
            },

            addTimelineToContextualizationTimelines(timeline) {
                if (! _.find(this.contextualizationTimelines, ['id', timeline.id])) {
                    if ( this.contextualizationTimelines.length < 4) {
                        this.$store.dispatch('addTimelineToContextualization', timeline);    
                    } else {
                        this.$buefy.toast.open({
                            message: 'Malheureusement, vous ne pouvez contextualiser que 4 lignes du temps. Veuillez en supprimer une.',
                            type: 'is-danger'
                        });
                    }
                }
            },

            fetchTimelinesCatalog() {
                this.loading = true;

                axios.get('/api/v1/timelines')
                     .then(response => {
                        this.timelines = response.data.timelines;
                        this.loading = false;
                    });
            },

            fetchUserTimelines() {
                this.loading = true;

                axios.get('/api/v1/account/timelines')
                     .then(response => {
                        this.timelines = response.data.timelines;
                        this.timelines.forEach(function (timeline) {
                            if (timeline.owner.id == this.user.id) {
                                timeline.personal = true;
                            } else {
                                timeline.personal = false;    
                            }
                        }, this);
                        this.policies = response.data.policies;
                        this.loading = false;
                });
            }
        },

        created() {
            Bus.$on('timelines.fetch', () => this.fetchUserTimelines());

            if (this.visibility == 'personal' || this.visibility == 'shared') {
                this.fetchUserTimelines();    
            }

            if (this.visibility == 'public') {
                this.fetchTimelinesCatalog();
            }
            
        },

        destroyed() {
            Bus.$off('timelines.fetch');
        },

        breadcrumb () {
            return {
                label: 'Commemoria',
            }
        }
    }
</script>

<style>
[v-cloak] {display: none}

#timelines-visibility a.dropdown-item.is-active {
    font-weight: bolder;
}
</style>